module.exports = __webpack_public_path__ + "static/img/67066G_C_03_20170813_LC.9d7110d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_C_03_20170813_LC.png
// module id = 0ZU3
// module chunks = 0